import { useParams, Link } from "react-router-dom";
import { MapPin, ArrowLeft } from "lucide-react";
import ProviderCard from "../components/ProviderCard";
import { CITIES, PROVIDERS } from "../mock";
import { useContent } from "../context/ContentContext";

function CityGrid() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
      {CITIES.map((c, i) => (
        <Link key={i} to={`/locations/${c[2]}`} className="card-hover flex items-center justify-between rounded-xl border border-slate-200 bg-white px-4 py-3 text-[14px] transition-colors hover:border-[var(--brand-blue)]">
          <span className="flex items-center gap-2 font-medium text-[var(--ink)]"><MapPin size={14} className="text-slate-400" />{c[0]}</span>
          <span className="text-[12px] font-semibold text-[var(--brand-blue)]">{c[1]}</span>
        </Link>
      ))}
    </div>
  );
}

export default function Locations() {
  const { city } = useParams();
  const { c } = useContent();
  const lc = c.locations;
  const found = CITIES.find((x) => x[2] === city);

  if (city && found) {
    const wanted = ["master-odor-removal", "biosweep", "servpro"];
    const list = wanted.map((s) => PROVIDERS.find((p) => p.slug === s)).filter(Boolean);
    return (
      <main>
        <section className="bg-[var(--navy)] py-16 lg:py-20">
          <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
            <Link to="/locations" className="inline-flex items-center gap-2 text-[14px] font-medium text-slate-300 hover:text-white"><ArrowLeft size={16} /> All locations</Link>
            <p className="mt-6 text-[12px] font-bold uppercase tracking-[0.14em] text-[#5aa0e0]">{lc.heroEyebrow}</p>
            <h1 className="font-display mt-3 text-[38px] font-extrabold leading-tight tracking-tight text-white sm:text-[48px]">Odor Removal in {found[0]}, {found[1]}</h1>
            <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-slate-300">Compare verified odor removal specialists serving {found[0]} and the surrounding {found[1]} area.</p>
          </div>
        </section>
        <section className="bg-[#f7f8fa] py-16 lg:py-20">
          <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
            <h2 className="font-display text-[24px] font-bold text-[var(--ink)]">Featured providers in {found[0]}</h2>
            <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
              {list.map((p) => <ProviderCard key={p.slug} p={p} />)}
            </div>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main>
      <section className="bg-[var(--navy)] py-16 lg:py-24">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-[#5aa0e0]">{lc.heroEyebrow}</p>
          <h1 className="font-display mt-3 text-[38px] font-extrabold leading-tight tracking-tight text-white sm:text-[48px]">{lc.heroTitle}</h1>
          <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-slate-300">{lc.heroSubtitle}</p>
        </div>
      </section>
      <section className="bg-white py-16 lg:py-20">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8"><CityGrid /></div>
      </section>
    </main>
  );
}
